angular
    .module('tradersyard')
    .run([
        'graph-api-client',
        'graph-post-factory',
        function ($api, $factory) {
            $api.factory.post = $factory;
        },
    ])
    .factory('graph-post-factory', [
        '$q',
        'graph-api-client',
        'graph-storage-factory',
        'graph-photo-factory',
        'graph-video-factory',
        'graph-document-factory',
        'graph-link-factory',
        function ($q, client, storage, photo, video, document, link) {
            function posts(entry, id) {
                var isPublic = entry === 'public';

                if (entry === 'user') entry = undefined;

                this.query = function (options) {
                    return client.get(isPublic ? ['public/feed'] : [entry, id, 'feed'], options);
                };

                this.create = function (data, options) {
                    return client.post(isPublic ? ['public/feed'] : [entry, id, 'feed'], data, options);
                };

                this.publishToFacebook = function (post_id, data, options) {
                    var request = ['feed', post_id, 'facebook/publish'];

                    return client.post(request, data, options);
                };

                this.update = function (id, data, options) {
                    return client.post(['post', id], data, options);
                };

                this.delete = function (post_id, options) {
                    return client.delete(['post', post_id], options);
                };

                this.storage = function (post_id) {
                    return new storage.storages('post', post_id);
                };

                this.photos = function (post_id) {
                    return new photo.entry('post', post_id);
                };

                this.videos = function (post_id) {
                    return new video.entry('post', post_id);
                };

                this.documents = function (post_id) {
                    return new document.entry('post', post_id);
                };

                this.links = function (post_id) {
                    return new link.entry('post', post_id);
                };
            }

            /**
             *  @type {String}
             */
            return {
                entry: function (entry, id, term) {
                    return new posts(entry, id, term);
                },
                getPostById: function (postId) {
                    return client.get('post/' + postId).then(function (resp) {
                        return resp.data.state === 0 ? resp.data.data : $q.reject('Post could not be loaded');
                    });
                },
                queryRecommended: function (options) {
                    return client.get('recommended/feed', options);
                },
            };
        },
    ]);
